var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 348,
    height: 206,
    viewBox: "0 0 348 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "next_svg__a",
    d: "M193.17-3.23l-.361.187a22.1 22.1 0 00-11.71 19.5l-.001 34.987H23.547c-11.147 0-19.1 3.903-23.82 11.272-3.251 5.076-4.7 11.104-5.165 19.003l-.064 1.23c-.019.415-.035.835-.05 1.26l-.026.929-.02.974-.014 1.004-.012 1.056v2.233l.008 1.289.017 1.249.025 1.211c.01.398.022.79.036 1.176l.046 1.141c.017.375.036.745.056 1.109l.069 1.077c.42 6.021 1.426 10.622 3.5 15.121l.184.392c4.417 9.221 12.826 14.38 25.23 14.38l157.551-.001.001 34.987a22.07 22.07 0 0012.072 19.678 22.176 22.176 0 0010.03 2.411c4.652 0 9.21-1.468 12.995-4.232l101.309-73.53a22.096 22.096 0 009.12-17.866c0-7.082-3.39-13.727-9.125-17.88L216.182-1.42a22.167 22.167 0 00-22.615-2.007l-.396.195zm16.41 10.92l101.316 73.534a10.821 10.821 0 014.479 8.773c0 3.456-1.664 6.716-4.482 8.764l-101.319 73.537a10.8 10.8 0 01-6.373 2.077c-1.694 0-3.38-.404-4.939-1.193a10.817 10.817 0 01-5.913-9.646V117.3H23.547c-8.232 0-12.689-2.792-15.198-8.233-1.137-2.466-1.843-5.218-2.25-8.705l-.092-.851a57.637 57.637 0 01-.081-.881l-.07-.912c-.012-.155-.022-.311-.032-.468l-.055-.962a87.175 87.175 0 01-.024-.493l-.041-1.013-.032-1.05-.024-1.088-.008-.559-.014-1.147v-.589l.005-2.441.014-1.277.023-1.194.026-.882.016-.463.04-.91.047-.888.028-.436.062-.855.072-.834.081-.812c.029-.268.06-.531.092-.791l.102-.77c1.485-10.508 6.04-14.995 16.917-15.1l169.198-.002V16.458a10.85 10.85 0 015.645-9.515l.264-.14a10.915 10.915 0 0111.323.887z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "next_svg__b",
    d: "M203.724 131.925v40.611c0 6.19 3.471 11.854 8.996 14.664a16.541 16.541 0 007.48 1.8c3.417 0 6.822-1.065 9.678-3.15l101.323-73.54A16.47 16.47 0 00338 98.998c0-5.28-2.526-10.23-6.8-13.325L229.879 12.133a16.54 16.54 0 00-17.158-1.35 16.474 16.474 0 00-8.996 14.675v40.611H40.547C17.794 66.069 17 84.199 17 98.749c0 13.562.794 33.176 23.547 33.176h163.177z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#7084B1",
    fillRule: "nonzero",
    transform: "translate(17 9)",
    xlinkHref: "#next_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#7084B1",
    strokeWidth: 11.25,
    xlinkHref: "#next_svg__b"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.532f1d5f.svg";
export { ForwardRef as ReactComponent };